import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { TFunction } from "i18next";
import { TbCar } from "react-icons/tb";

import { TableHeader } from "@/components/TableHeader";
import { PlanAssignationCell } from "@/pages/Plannn/components/table/PlanAssignationColumn";
import { Task } from "@/types/tasks.types";

const TrackingDriverColumn = ({ t }: { t: TFunction }): GridColDef<Task> => {
    return {
        field: "driverId",
        headerName: t("driver"),
        minWidth: 220,
        editable: false,
        renderHeader: (params) => <TableHeader Component={TbCar} title={params.colDef.headerName!} />,
        valueGetter: (_val, row) => row.driverId,
        renderCell: (params: GridRenderCellParams<Task>) => {
            return <PlanAssignationCell error={undefined} value={params.row.driverId} />;
        },
    };
};

export default TrackingDriverColumn;
